<template>
	<div class="formButton">
		<slot name="otherButtons"></slot>
		<b-button
			:class="$CoreSettingsJs.isMobile() ? 'btnMargin' : 'ml-1 mr-1'"
			variant="teal"
			size="sm"
			v-if="is_view == 0 && enable_save_draft"
			:disabled="permission_save == false || permission_save == null"
			@click="$emit('saveDraf')"
		>
			<span v-text="$t('COMMON.BTN_SAVE_AS_DRAFT')"></span>
		</b-button>
		<b-button
			:class="$CoreSettingsJs.isMobile() ? 'btnMargin' : 'ml-1 mr-1'"
			variant="success"
			size="sm"
			v-if="is_view == 0 && permission_create && permission_save && enableSaveNNew"
			:disabled="is_saving"
			@click="$emit('save_new')"
		>
			<b-icon v-if="is_saving" icon="arrow-clockwise" animation="spin-pulse"></b-icon>
			<b-icon-pencil-square class="mr-1"></b-icon-pencil-square>
			<span v-text="$t('COMMON.BTN_SAVE_AND_NEW')"></span>
		</b-button>
		<b-button
			:class="$CoreSettingsJs.isMobile() ? 'btnMargin' : 'ml-1 mr-1'"
			type="submit"
			variant="success"
			size="sm"
			v-if="is_view == 0"
			:disabled="state == 0 || is_saving == true || permission_save == null || permission_save == false"
		>
			<b-icon v-if="is_saving" icon="arrow-clockwise" animation="spin-pulse"></b-icon>
			<i v-else class="fa fa-save"></i>
			<span v-text="saveText == null ? $t('COMMON.BTN_SAVE') : saveText"></span>
		</b-button>
		<b-button
			:class="$CoreSettingsJs.isMobile() ? 'btnMargin' : 'ml-1 mr-1'"
			:to="createRoute"
			variant="primary"
			size="sm"
			v-show="is_view == 1 && !$CoreSettingsJs.emptyObjectValidation(createRoute) && permission_create"
		>
			<span v-text="$t('COMMON.BTN_CREATE', { btn_name: title })"></span>
		</b-button>
		<b-button
			:class="$CoreSettingsJs.isMobile() ? 'btnMargin' : 'ml-1 mr-1'"
			:to="editRoute"
			variant="success"
			size="sm"
			v-if="is_view == 1 && editRoute && (permission_edit == null || permission_edit == true)"
			:disabled="editState == 0"
		>
			<b-icon-pencil-square></b-icon-pencil-square>
			<span class="ml-1" v-text="$t('COMMON.BTN_EDIT')"></span>
		</b-button>
		<b-button
			:class="$CoreSettingsJs.isMobile() ? 'btnMargin' : 'ml-1 mr-1'"
			variant="danger"
			:to="indexRoute"
			class="ml-1"
			size="sm"
			v-if="indexRoute && (permission_list == null || permission_list == true)"
		>
			<span v-text="$t('COMMON.BTN_BACK')"></span>
		</b-button>
	</div>
</template>

<style scoped lang="scss">
.btnMargin {
	margin: 4px 5px !important;
}
</style>

<script>
export default {
	name: "FormButton",
	props: {
		indexRoute: String,
		editRoute: null,
		is_view: null,
		modules: null,
		state: null,
		editState: null,
		saveText: null,
		permission_save: null,
		permission_list: null,
		permission_edit: null,
		is_saving: {
			default: false,
			type: Boolean
		},
		enable_save_draft: {
			type: Boolean,
			default: false
		},
		createRoute: {
			type: String,
			default: null
		},
		permission_create: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ""
		},
		enableSaveNNew: {
			type: Boolean,
			default: false
		}
	}
};
</script>
